<div class="d-grid">
  <b>{{ 'portfolio.comments' | translate }}</b>
  <div #commentArea class="border border-2 rounded me-2 mt-2 field-height">
    <p
      [gstarTextareaOverflowButton]="true"
      [fieldTitle]="'portfolio.comments' | translate"
      [textContent]="comment()"
      [htmlElement]="commentArea"
      class="pt-2 p-1 text-muted pe-none m-0 white-space-pre">
      {{ comment() }}
    </p>
  </div>
</div>
